
export class OrderUpdate {
  orderId: number;
  statusId: number;

  constructor(values: object = {}) {
    Object.assign(this, values);
  }
}
